module.exports = __webpack_public_path__ + "static/img/thunder.db60585.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thunder.jpeg
// module id = SQT8
// module chunks = 1